module.exports = __webpack_public_path__ + "prod/1.2.3/img/ConvenientlyPurchase.5f1b0a33.svg";